<template>

  <div class="min-vh-100 d-flex justify-content-center align-items-center bg-light-gray">
    <div class="card shadow-sm border-0 rounded-4 overflow-hidden" style="max-width: 420px; width: 100%;">
      <div class="card-body p-5">
        <template
          v-if="!isSubmitted"
        >
          <div class="text-center mb-4">
            <div class="d-inline-flex align-items-center justify-content-center gap-2 mb-2">
              <i class="fa-solid fa-utensils text-theme fs-2" />
              <h2 class="fw-bold text-dark m-0" style="letter-spacing: -0.5px;">
                {{ $ln($brand) }}
              </h2>
            </div>
            <p class="text-muted small">
              {{ $appName }} · {{ $t('Create your account to get started') }}
            </p>
          </div>
          <div
            v-if="registerFailuredMessage"
            class="alert alert-danger d-flex align-items-center p-1"
            style="font-size: 14px;"
            role="alert"
          >
            <i class="fa-solid fa-circle-exclamation me-2 ms-1" />
            <div>
              {{ $t(registerFailuredMessage) }}
            </div>
          </div>
          <div class="mb-3">
            <label
              for="fullname"
              class="form-label small fw-bold text-secondary"
            >
              {{ $t('Full Name') }}
              <span class="text-danger">*</span>
            </label>
            <div class="custom-input-group input-group input-group-sm">
              <span class="input-group-text bg-white border-end-0 text-muted">
                <i class="fa-regular fa-id-card"></i>
              </span>
              <input
                v-model="v$.form.fullname.$model"
                type="text"
                class="form-control border-start-0 ps-0"
                name="fullname"
                id="fullname"
                placeholder="e.g. Somsri Meesuk"
                required
              >
            </div>
            <div v-for="error of v$.form.fullname.$errors"
              class="d-block invalid-feedback"
              :key="error.$uid"
            >
              {{ error.$message }}
            </div>
          </div>
          <div class="mb-3">
            <label
              for="email"
              class="form-label small fw-bold text-secondary"
            >
              {{ $t('Email Address') }}
            </label>
            <div class="custom-input-group input-group input-group-sm">
              <span class="input-group-text bg-white border-end-0 text-muted">
                <i class="fa-regular fa-envelope"></i>
              </span>
              <input
                v-model="v$.form.email.$model"
                type="email"
                class="form-control border-start-0 ps-0"
                name="email"
                id="email"
                placeholder="name@example.com"
                required
              >
            </div>
            <div v-for="error of v$.form.email.$errors"
              class="d-block invalid-feedback"
              :key="error.$uid"
            >
              {{ error.$message }}
            </div>
          </div>
          <div class="mb-3">
            <label
              for="telephone1"
              class="form-label small fw-bold text-secondary"
            >
              {{ $t('Telephone') }}
              <span class="text-danger">*</span>
            </label>
            <div class="custom-input-group input-group input-group-sm">
              <span class="input-group-text bg-white border-end-0 text-muted">
                <i class="fa-solid fa-phone"></i>
              </span>
              <input
                v-model="v$.form.telephone1.$model"
                type="tel"
                class="form-control border-start-0 ps-0"
                name="telephone1"
                id="telephone1"
                placeholder="08x-xxx-xxxx"
                required
              >
            </div>
            <div v-for="error of v$.form.telephone1.$errors"
              class="d-block invalid-feedback"
              :key="error.$uid"
            >
              {{ error.$message }}
            </div>
          </div>
          <div class="mb-3">
            <label
              for="usernanme"
              class="form-label small fw-bold text-secondary"
            >
              {{ $t('Username') }}
              <span class="text-danger">*</span>
            </label>
            <div class="custom-input-group input-group input-group-sm">
              <span class="input-group-text bg-white border-end-0 text-muted">
                <i class="fa-solid fa-at"></i>
              </span>
              <input
                v-model="v$.form.username.$model"
                type="text"
                class="form-control border-start-0 ps-0"
                name="usernanme"
                id="usernanme"
                placeholder="e.g., somsri.m"
                required
              >
            </div>
            <div v-for="error of v$.form.username.$errors"
              class="d-block invalid-feedback"
              :key="error.$uid"
            >
              {{ error.$message }}
            </div>
          </div>
          <div class="mb-3">
            <label
              class="form-label small fw-bold text-secondary"
              for="password"
            >
              {{ $t('Password') }}
              <span class="text-danger">*</span>
            </label>
            <div class="custom-input-group input-group input-group-sm">
              <span class="input-group-text bg-white border-end-0 text-muted">
                <i class="fa-solid fa-lock" />
              </span>
              <input
                v-model.trim="v$.form.password.$model"
                :type="showPassword ? 'text': 'password'"
                class="form-control border-start-0 border-end-0 ps-0"
                placeholder="••••••••"
                name="password"
                id="password"
                required
              >
              <span
                class="input-group-text bg-white border-start-0 text-muted cursor-pointer"
                @click="showPWD"
              >
                <a
                  class="cursor-pointer"
                  style="color: #000000;"
                >
                  <i class="far " :class="showPassword ? 'fa-eye': 'fa-eye-slash'" />
                </a>
              </span>
            </div>
            <div v-for="error of v$.form.password.$errors"
              class="d-block invalid-feedback"
              :key="error.$uid"
            >
              {{ error.$message }}
            </div>
          </div>
          <div class="mb-3">
            <label
              class="form-label small fw-bold text-secondary"
              for="repeatPassword"
            >
              {{ $t('Confirm Password') }}
              <span class="text-danger">*</span>
            </label>
            <div class="custom-input-group input-group input-group-sm">
              <span class="input-group-text bg-white border-end-0 text-muted">
                <i class="fa-solid fa-check-double" />
              </span>
              <input
                v-model.trim="v$.form.repeatPassword.$model"
                type="password"
                class="form-control border-start-0 border-end-0 ps-0"
                placeholder="••••••••"
                name="repeatPassword"
                id="repeatPassword"
                required
              >
            </div>
            <div v-for="error of v$.form.repeatPassword.$errors"
              class="d-block invalid-feedback"
              :key="error.$uid"
            >
              {{ error.$message }}
            </div>
          </div>
          <ladda
            text="Register Now"
            :btn-class="'btn btn-theme w-100 py-2 fw-bold text-white shadow-sm mb-3'"
            :loading="btnLoading"
            @click="handleRegister"
            :disabled="v$.$invalid"
          />
          <div class="text-center">
            <span class="small text-muted">{{ $t("Already have an account") + '? ' }}</span>
            <router-link
              class="small text-decoration-none text-theme fw-bold"
              to="/login"
            >
              {{ $t('Login here') }}
            </router-link>
          </div>
        </template>

        <div v-else class="text-center py-3 animate-fade-in">

          <div class="mb-4 d-inline-block rounded-circle bg-green-50 p-3">
            <i class="fa-regular fa-circle-check text-success" style="font-size: 3.5rem;"></i>
          </div>

          <h4 class="fw-bold text-dark mb-2">{{ $t('Request Sent') + '!' }}</h4>

          <p class="text-muted mb-4 small px-3">
            {{ $t('Your registration has been submitted successfully.') }}
            <br>
            {{ $t('Please contact your manager or system administrator to approve your account.') }}
          </p>

          <div class="alert alert-light border bg-light text-secondary mb-4 py-2 d-inline-flex align-items-center gap-2">
             <i class="fa-solid fa-clock text-warning"></i>
             <span class="small">{{ $t('Status') }}: <strong>{{ $t('Pending Approval') }}</strong></span>
          </div>

          <button @click="() => {$router.push('/login')}" class="btn btn-theme w-100 py-2 fw-bold text-white shadow-sm">
            {{ $t('Back to Login') }}
          </button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, email, numeric, minLength, maxLength, sameAs, helpers } from '@vuelidate/validators';
import Ladda from '@/plugins/Ladda.vue';
import { Auth } from '@/services/endpoint/auth-api.service';
import Cookies from 'js-cookie';
export default {
  name: 'Login',
  components: {
    Ladda
  },
  data() {
    return {
      btnLoading: false,
      registerFailuredMessage: '',
      form: {
        fullname: '',
        telephone1: '',
        email: '',
        username: '',
        password: '',
        repeatPassword: ''
      },
      isSubmitted: false,
      showPassword: false,
    }
  },
  validations () {
    return {
      form: {
        fullname: {
          required: helpers.withMessage(this.$t('Please enter fullname'), required)
        },
        telephone1: {
          required: helpers.withMessage(this.$t('Please enter telephone'), required),
          numeric: helpers.withMessage(this.$t('Telephone must be only numeric.'), numeric),
          minLength: helpers.withMessage(
            ({
              $params,
            }) => this.$t('Telephone must be at least') +  ' ' + $params.min + ' ' + this.$t('characters long.'),
            minLength(9)
          ),
          maxLength: helpers.withMessage(
            ({
              $params,
            }) => this.$t('Telephone cannot exceed') +  ' ' + $params.max + ' ' + this.$t('characters.'),
            maxLength(10)
          ),
        },
        email: {
          //required: helpers.withMessage(this.$t('Please enter email'), required),
          email: helpers.withMessage(this.$t('Email invalid'), email)
        },
        username: {
          required: helpers.withMessage(this.$t('Please enter username'), required)
        },
        password: {
          required: helpers.withMessage(this.$t('Please enter password'), required),
          minLength: helpers.withMessage(
            ({
              $params,
            }) => this.$t('password must be at least') +  ' ' + $params.min + ' ' + this.$t('characters long.'),
            minLength(8)
          ),
          maxLength: helpers.withMessage(
            ({
              $params,
            }) => this.$t('password cannot exceed') +  ' ' + $params.max + ' ' + this.$t('characters.'),
            maxLength(16)
          ),
        },
        repeatPassword: {
          required: helpers.withMessage(this.$t('Please enter confirm password'), required),
          sameAsPassword: helpers.withMessage(this.$t('Passwords do not match.'), sameAs(this.form.password))
        }
      }
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  async mounted() {
  },
  methods: {
    showPWD(){
      this.showPassword = !this.showPassword;
    },
    async handleRegister() {
      this.btnLoading = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.btnLoading = false;
        return;
      }
      let params = _.cloneDeep(this.form);
      if (params.email == '' || params.email == null) {
        delete params.email;
      }
      delete params.repeatPassword;
      await Auth.register(params).then(res => {
        this.isSubmitted = true;
        this.btnLoading = false;
      }).catch(err => {
        if (err.response && err.response.data.message) {
          this.registerFailuredMessage = err.response.data.message;
          this.btnLoading = false;
          return;
        }
        return;
      });

    }
  },
  created() {
  }
}
</script>
